var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImagesIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ion:images-outline"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.5 3.5V3C13.4988 2.60253 13.3404 2.22167 13.0594 1.94061C12.7783 1.65956 12.3975 1.50115 12 1.5H2C1.60253 1.50115 1.22167 1.65956 0.940615 1.94061C0.65956 2.22167 0.501154 2.60253 0.5 3V11C0.501154 11.3975 0.65956 11.7783 0.940615 12.0594C1.22167 12.3404 1.60253 12.4988 2 12.5H2.5",
    stroke: "#757575",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M14.0628 4H4.43719C3.64345 4 3 4.64345 3 5.43719V13.0628C3 13.8565 3.64345 14.5 4.43719 14.5H14.0628C14.8565 14.5 15.5 13.8565 15.5 13.0628V5.43719C15.5 4.64345 14.8565 4 14.0628 4Z",
    stroke: "#757575",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M11.6539 7.81855C12.185 7.81855 12.6155 7.39113 12.6155 6.86387C12.6155 6.33661 12.185 5.90918 11.6539 5.90918C11.1229 5.90918 10.6924 6.33661 10.6924 6.86387C10.6924 7.39113 11.1229 7.81855 11.6539 7.81855Z",
    stroke: "#757575",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M10.6922 11.63L7.96875 8.93036C7.79465 8.75835 7.56178 8.65878 7.31714 8.65177C7.0725 8.64475 6.8343 8.7308 6.65063 8.89255L3 12.1135M8.28844 14.4997L11.9944 10.8207C12.1649 10.6525 12.3917 10.5534 12.631 10.5427C12.8702 10.5319 13.105 10.6101 13.29 10.7622L15.5 12.5907",
    stroke: "#757575",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImagesIcon);
export default __webpack_public_path__ + "static/media/images-icon.25741acc8484df2692db100a85e699c7.svg";
export { ForwardRef as ReactComponent };